export default __webpack_public_path__ + "static/media/Q6-4.aa64db08.jpg";